<template>
  <div :class="componentClass.root">
    <div v-if="title" :class="componentClass.element('title')">{{ title }}</div>

    <ul :class="componentClass.element('list')">
      <PmSidebarResourceGroupItemPure
        v-for="resource in resourcesNormalized"
        :key="resource.id"
        :class="componentClass.element('listItem')"
        :label="resource.title"
        :is-highlighted="resource.isHighlighted"
        @highlight="emit('highlight', resource.id)"
        @un-highlight="emit('unHighlight')"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useComponentClass } from '@thomasaull-shared/composables'
import { RESOURCE_TYPE, type ResourceType } from '@/constants/persoplan'
import { defaultSortVehicles } from '@/utilities/persoplan'
import PmSidebarResourceGroupItemPure from '@/components/persoplan/PmSidebarResourceGroupItemPure.vue'

export interface Resource {
  title?: string
  id: number
  loadingCapacity?: number
  isProMusik?: boolean
  isHighlighted?: boolean
}

export interface Props {
  title?: string
  resources?: Resource[]
  type: ResourceType
}

const props = withDefaults(defineProps<Props>(), {
  resources: () => [],
})

export interface Emits {
  highlight: [id: number]
  unHighlight: []
}

const emit = defineEmits<Emits>()

const componentClass = useComponentClass({ props })

const resourcesNormalized = computed(() => {
  if (props.type === RESOURCE_TYPE.VEHICLE) {
    return vehiclesNormalized.value
  }

  return props.resources
})

const vehiclesNormalized = computed(() => {
  return defaultSortVehicles(props.resources)
})
</script>

<style lang="scss">
.PmSidebarResourceGroupPure {
  $spaceVertical: 8px;
  $spaceItemVertical: 6px;

  $block: &;

  position: relative;
  padding-bottom: $spaceVertical;

  &-title {
    @include mixin.textLabel;

    padding-top: $spaceItemVertical;
    padding-bottom: $spaceItemVertical;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: 1;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: color.$text-default;

    &::after {
      content: '';
      flex-basis: 100%;
      height: 1px;
      background-color: color.$gray-200;
      // margin-right: -10px;
    }
  }

  &-list {
    list-style: none;
    cursor: default;
    padding: 0;
    margin: 0;
  }
}
</style>
